import TContext from "../context/TContext";

/**
 *
 *
 * @interface IPanelContext
 */
export interface IConfigContext {
    config: { [key: string]: any };
    getConfig: () => { [key: string]: any };
}

const ConfigContext = new TContext<IConfigContext>({
    config: {},
    getConfig: () => {
        return {};
    }
});

export default ConfigContext;
